module.exports = __webpack_public_path__ + "static/media/hit.3dcce9b9.svg";